
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import AulaService from "@/service/v1/sigap/AulaService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "AulaIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class AulaIndex extends IndexModelTable {
    public status_id: any = 1;
    public status: any = null;
    public data_min: any = null;
    public data_max: any = null;
    public meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    public dias = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
    public instrutorCPF = "";
    public controladorId = "";
    public pelotao = "";
    public numero = "";
    public turma = "";
    public disciplina = "";
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEdicao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get hj() {
        return new Date().getFullYear() + "-" + this.meses[new Date().getMonth()] + "-" + this.dias[new Date().getDate()];
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.data_min = null;
        this.data_max = null;
        this.instrutorCPF = "";
        this.controladorId = "";
        this.status_id = null;
        this.pelotao = "";
        this.numero = "";
        this.turma = "";
        this.disciplina = "";
        this.refreshTable();
    }

    created() {
        this.data_min = this.hj;
        this.service = new AulaService();
        this.getStatus();
        this.config.order = [[5, "desc"],[6, "desc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    instrutorCPF: this.instrutorCPF,
                    ControladorId: this.controladorId,
                    status: this.status_id,
                    pelotao: this.pelotao,
                    numero: this.numero,
                    disciplina: this.disciplina,
                    turma: this.turma,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: "id", name: "id", searchable: false },
            { data: "numero", name: "numero", class: "desktop", searchable: false },
            { data: "disciplina", name: "disciplina", searchable: false },
            { data: "aulaDisciplina", name: "auladisciplina", searchable: false },
            { data: "turma", name: "turma", class: "desktop", searchable: false },
            { data: "data", name: "data", class: "desktop", searchable: false },
            { data: "inicio", name: "inicio", class: "desktop", searchable: false },
            { data: "instrutor", name: "instrutor", class: "desktop", searchable: false },
            { data: "status", name: "status", searchable: false, class: "text-center desktop" },
            { data: "natureza", name: "natureza", searchable: false, class: "text-center desktop" },
        ];
        this.config.columnDefs = [
            {
                targets: 1,
                render: function (row, type, val) {
                    return row + "/" + val.disciplina?.cargaHoraria;
                }
            },
            {
                targets: 2,
                render: function (row) {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 3,
                render: function (row) {
                    return row != null ? row.pelotao : "";
                }
            },
            {
                targets: 4,
                render: function (row) {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 7,
                render: (row) => {
                    return row != null ? row.nome : "";
                },
            },
            {
                targets: 8,
                render: (row) => {
                    return row.nome ?? "";
                },
            },
            {
                targets: 9,
                render: (row) => {
                    return row.nome ?? "";
                },
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 10,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-aula ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';

                        if (val.status.id < 3 && this.hasPermissaoEdicao) {
                            texto = texto + '<button class="btn btn-pmes-warning btn-sm" btn-editar-aula ' + buttom + ' title="Editar"><i class="fa fa-edit"></i></button>';
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir-aula ' + buttom + '><i class="fa fa-trash"></i></button>';
                        }
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-show-aula]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            const routeData = this.$router.resolve({ name: "sigap_aulas_show", params: { id: id } });
            window.open(routeData.href, "_blank");
        });
        $("[btn-editar-aula]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            const routeData = this.$router.resolve({ name: "sigap_aulas_editar", params: { id: id } });
            window.open(routeData.href, "_blank");
        });
        $("[btn-excluir-aula]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            this.excluirModelo(id);
        });
    }
}
